import React from "react";
import ReactLoading from "react-loading";

const Loading = ({ color }) => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <ReactLoading
        type={"spin"}
        color={color ? color : "#005F6A"}
        height={"100%"}
        width={"100%"}
      />
    </div>
  );
};

export default Loading;
